// src/Components/Drawer/CustomDrawer/DrawerUtils.js

export const drawerWidth = 400;
export const SIDEBAR_WIDTH = 60;
export const MENU_HEIGHT = '60px';

// --- STYLES ---
export const drawerStyles = {
  fieldContainer: { display: 'flex', flexDirection: 'column', width: '100%' },
  label: {
    color: '#00008B',
    fontWeight: 'bold',
    fontSize: '0.65rem',
    textTransform: 'uppercase',
    marginBottom: '0px',
    marginLeft: '2px',
    lineHeight: 1.2,
  },
  valueBox: {
    borderRadius: '4px',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 4px',
    overflow: 'hidden',
    transition: 'background-color 0.3s ease',
  },
  input: {
    border: 'none',
    outline: 'none',
    width: '100%',
    backgroundColor: 'transparent',
    fontSize: '0.8rem',
    fontFamily: 'inherit',
    color: '#333',
    padding: 0,
    margin: 0,
    cursor: 'text',
  },
  activeInput: {
    cursor: 'text',
  },
};

// --- INITIAL STATE HELPERS ---

export const getInitialPhotos = (marker) => {
  if (marker && marker.photos && Array.isArray(marker.photos)) {
    return marker.photos.map((p) => {
      // AMENDED: Aggressively restore video typing if it was lost in a previous save cycle
      const url =
        p.url ||
        p.img ||
        p.videoUrl ||
        p.video ||
        p.src ||
        p.media ||
        p.clipUrl ||
        p.downloadUrl ||
        '';
      let inferredType = p.type || 'image';
      if (
        inferredType === 'image' &&
        url.match(/\.(mp4|mov|webm|avi|mkv|wmv|flv|mts|m4v)/i)
      )
        inferredType = 'video';
      if (inferredType === 'image' && url.match(/\.(mp3|wav|ogg|aac)/i))
        inferredType = 'audio';

      return {
        id: p.id,
        img: url,
        title: p.fileName || 'Untitled',
        type: inferredType, // THE FIX: Prevent data corruption by preserving the type
        file: null,
      };
    });
  }
  return [];
};

export const getInitialPhotoDescs = (marker) => {
  const descs = {};
  if (marker && marker.photos && Array.isArray(marker.photos)) {
    marker.photos.forEach((p) => {
      if (p.description) descs[p.id] = p.description;
    });
  }
  return descs;
};

export const getInitialPhotoSelection = (marker) => {
  if (
    marker &&
    marker.photos &&
    Array.isArray(marker.photos) &&
    marker.photos.length > 0
  ) {
    return new Set([marker.photos[0].id]);
  }
  return new Set();
};

export const getInitialDocs = (marker) => {
  if (marker && marker.documents && Array.isArray(marker.documents)) {
    return marker.documents.map((d) => ({
      id: d.id,
      fileName: d.fileName || 'Untitled',
      fileSize: d.fileSize || 0,
      fileType: d.fileType || '',
      url: d.url,
      timestamp: d.timestamp,
      fileObject: null,
    }));
  }
  return [];
};
